import $ from 'jquery';
import Player from '@vimeo/player';

$('.js--play').click( function () {
    var content     = $(".js--content"),
        videoWrap   = $(".js--video-wrap"),
        video       = $(".js--video")[0],
        player      = new Player( video );

    function playProperties() {
        videoWrap.addClass( 'is-playing' );
        videoWrap.fadeTo( 700, 1 );
        content.fadeOut();
    }

    function stopProperties() {
        videoWrap.removeClass( 'is-playing' );
        videoWrap.fadeTo( 700, 0 );
        content.fadeIn();
    }

    if( videoWrap.hasClass( 'is-playing' ) ) {
        stopProperties();
        player.pause();
    } else {
        playProperties();
        player.play();
    }

    player.on('pause', function() {
        stopProperties();
    });
    player.on('ended', function() {
        stopProperties();
    });
    player.on('play', function() {
        playProperties();
    });
});
